import moment from 'moment'
import { TDaysOfWeekSchema } from '../schema/DaysOfWeekSchema'

/**
 * Returns an array of iso days from TDaysOfWeekSchema
 * @param {TDaysOfWeekSchema} days { monday: true, tuesday: false, wednesday: true, thursday: false, friday: false, saturday: false, sunday: false }
 * @returns {Array} [1, 3]
 */
export const getIsoDays = (days: TDaysOfWeekSchema): number[] => {
  return Object.entries(days)
    .filter(([, value]) => value)
    .map(([key]) => moment().isoWeekday(key).isoWeekday())
}
